import { Pipe, PipeTransform } from '@angular/core'
import { toDate } from '../helpers/date-helper';
@Pipe({ 
    name: 'formatToLocal', 
})
export class FormatToLocal implements PipeTransform {
    transform(date: string) {
        if (date) {
            let d = new Date(date);
            return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
        }
        return '';
    }
}